'use strict';

import buildStore from "./data/store";
import {actionSetConfig} from "./data/action";
import {DEFAULT_DASHBOARD_QUERY_ARGS} from './data/defaults'

(function ($, oc, posts) {

    const store = buildStore();

    const $columns = $(".octavius-rocks-pageview-column");
    if (!$columns.length) return;

    const groupToIds = (group) => {
        return group.split(",")
            .map(id => {
                return parseInt(id);
            })
            .filter(n => {
                return !isNaN(n);
            });
    }

    const post_ids = [];
    $columns.each(function (i, el) {
        const $el = $(el);
        post_ids.push($el.data("post-id"));
        const groupIds = groupToIds($(el).data("posts-group"));
        groupIds.forEach(
            postId => {
                if (!post_ids.includes(postId)) {
                    post_ids.push(postId);
                }
            }
        );
        $el.wrap("<a href='"+Octavius_Rocks_Posts.dashboard+"'></a>");
        $el.parent().on("click", function(e){
            e.preventDefault();
            const oql = DEFAULT_DASHBOARD_QUERY_ARGS;
            oql.conditions.entries.push({
                relation: "OR",
                entries: groupIds.map(pid => (
                    {
                        field: "content_id",
                        compare: "=",
                        value: pid,
                    }
                ))
            });
            store.dispatch(actionSetConfig("queryArgs_Dashboard_object", oql));
            window.location.assign(this.href);
        });
    });
    posts.oql.conditions.entries[0].value = post_ids;

    const $loading = $("<span class='spinner is-active'></span>").css({
        width: 14,
        height: 14,
        backgroundSize: 14,
    });

    $("#pageviews a").append($loading);

    oc.api.get().then(get => {

        get.query(posts.oql).then(function (data) {
            if (data.error) {
                console.error(data);
            } else {

                const posts = {}

                const nullKey = "__null__"

                for (let entry of data.value) {
                    if (typeof posts[entry.content_id] !== typeof {}) posts[entry.content_id] = {}
                    const viewmodeKey = entry.viewmode ? entry.viewmode : nullKey;
                    if (typeof posts[entry.content_id][viewmodeKey] !== typeof undefined) {
                        posts[entry.content_id][viewmodeKey] += entry.hits;
                    } else {
                        posts[entry.content_id][viewmodeKey] = entry.hits;
                    }
                }
                for (let postId in posts) {
                    const $el = $("[data-post-id=" + postId + "]");
                    if(!$el.length) continue;
                    const groupIds = groupToIds($el.data("posts-group"));
                    const values = posts[postId];
                    groupIds.forEach(groupPostId => {
                        if(groupPostId+'' !== postId+'') {
                            values[groupPostId] = Object.values(posts[groupPostId])[0];
                        }
                    });
                    const overall = Object.values(values).reduce((acc, currentValue) => acc + currentValue);
                    $el.find("[data-rendered='true']").text(Number(overall).toLocaleString()).removeAttr("data-rendered");
                }
            }
            $loading.remove();
        }).catch(function (data) {
            $loading.remove();
            console.error("Error requesting Octavius.", data);
        });
    });


})(jQuery, WP_OctaviusRocks_Admin, Octavius_Rocks_Posts);